import React from "react";

type IconProps = {
  size?: number | string;
  color?: string;
};

export const SkipForward15MobileIcon = ({
  size,
  color,
}: IconProps): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "31"}
      height={size || "30"}
      viewBox="0 0 31 30"
      fill="none"
      style={{
        shapeRendering: "geometricPrecision",
        imageRendering: "-webkit-optimize-contrast",
      }}
    >
      <path
        d="M10.2718 28.3378C7.28618 27.2016 4.7788 25.0786 3.16584 22.3212C1.55289 19.5638 0.931347 16.3377 1.40437 13.1784C1.8774 10.019 3.41655 7.11646 5.76639 4.95235C8.11622 2.78824 11.1354 1.49274 14.3229 1.28085C17.5104 1.06896 20.6746 1.95342 23.2902 3.78744C25.9058 5.62147 27.8156 8.29478 28.7026 11.3637"
        stroke={color || "white"}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2525 1.25V11.433L19.1484 10.1779"
        stroke={color || "white"}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SkipForward15MobileIcon;
